import React from 'react';

export const AgencyRegistrationApplicationsIcon = props => {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path d='M0 0h24v24H0V0z' fill='none' />
      <path d='M17.3 17.6c-1.1-.7-2.2-1.3-3.3-2-.4-.2-.6-.2-.8.2-.3.5-.5 1-.9 1.4-1.1 1.2-2.9.9-3.7-.6-.4-.7-.3-1.5.1-2.2l1.8-3c-2.1-.5-3 0-4 1.7-.2.4-.9 1-1.3 1H3.1c-.6-.1-1.1.2-1.1.9v5c0 .7.4 1 1.1 1H5c1.1 0 2.1-.3 3 .3.7.5 1.5.9 2.2 1.3.9.5 1.7.4 2.5-.2.1-.1.4-.3.5-.2 1.3.2 1.3.2 2-1 .3-.5.5-1.1 1.3-.9.2 0 .4-.2.6-.4.2-.3.4-.6.6-1 .2-.5.1-1-.4-1.3z' />
      <path d='M22 19v-5c0-.8-.2-1-1-1-.9 0-2 .1-2.9 0-.5 0-1-.2-1.4-.4l-2.1-1.2c-.9-.5-2.6-.5-3 .1-.8 1.2-1.4 2.4-2.1 3.7-.3.6 0 1.3.5 1.6.6.3 1.2.1 1.6-.5.4-.6.7-1.1 1-1.7.3-.5.5-.6 1-.3 1.3.8 2.6 1.5 3.8 2.3 1.5.9 1.7 1.5.9 3.1 0 .1-.2.4-.2.4h3.2c.8-.1.7-.4.7-1.1z' />
      <path d='M7 3.5c0-.3.2-.5.5-.5H14v3.5c0 .3.2.5.5.5H18v5h1V5.8L15 2H7.5C6.7 2 6 2.7 6 3.5V12h1V3.5zM17.8 6H15V3.4L17.8 6z' />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/icons/AgencyRegistrationApplicationsIcon.jsx